import styles from './CategoryDonut.module.scss';
import { Props } from './CategoryDonut.types';

const RADIUS = 15.9;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
const STROKE_WIDTH = 7;

const CategoryDonut = ({ slices, centerLabel, size, ariaLabel }: Props) => {
  const total = slices.reduce((sum, slice) => sum + slice.value, 0);
  if (total <= 0) return null;

  let offset = 25;
  const arcs = slices.map(slice => {
    const length = (slice.value / total) * CIRCUMFERENCE;
    const arc = {
      key: slice.key,
      color: slice.color,
      dasharray: `${length} ${CIRCUMFERENCE - length}`,
      dashoffset: offset,
    };
    // Negative dashoffset moves clockwise from the top; keep them chained.
    offset = offset - length;
    return arc;
  });

  return (
    <svg
      viewBox="0 0 42 42"
      width={size}
      height={size}
      role="img"
      aria-label={ariaLabel}
      className={styles.donut}
    >
      <circle cx="21" cy="21" r={RADIUS} fill="none" stroke="#efe9e2" strokeWidth={STROKE_WIDTH} />
      {arcs.map(arc => (
        <circle
          key={arc.key}
          cx="21"
          cy="21"
          r={RADIUS}
          fill="none"
          stroke={arc.color}
          strokeWidth={STROKE_WIDTH}
          strokeDasharray={arc.dasharray}
          strokeDashoffset={arc.dashoffset}
        />
      ))}
      <text x="21" y="22.5" textAnchor="middle" className={styles.center}>
        {centerLabel}
      </text>
    </svg>
  );
};

export default CategoryDonut;
